import React from 'react';
import { useRecoilState } from 'recoil';
import { Box, Grid } from '@mui/material';
import { velocityState } from 'features/optimization/state/cfdConfigAtoms';
import { CustomNumberField } from 'shared/ui/CustomNumberField';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

export const VelocitySelector: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 3,
}) => {
  const [cfdVelocity, setCfdVelocity] = useRecoilState(velocityState);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(event.target.value);
    setCfdVelocity(isNaN(value) ? 0 : value); // Handle invalid input
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <CustomNumberField
            required
            label="velocity"
            type="number"
            value={cfdVelocity}
            onChange={handleChange}
            inputProps={{ step: 0.01 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#1e1e1e',
              },
              width: '100px',
              margin: '8px'
            }}
            disabled // TEMPORARY
          />
        </Grid>
      </Grid>
    </Box>
  );
};
